/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import DashboardContainer from './dashboard/DashboardContainer';
import TransactionContainer from './transaction/container/TransactionContainer';

function EWalletServiceContainer({ match }) {
  return (
    <>
      <div className="module-inner">
        <div className="module-inner-title">Cash Transfer</div>
        <div className="generic-module-nav mb-3">
          <NavLink
            exact
            className="nav-link"
            activeClassName="active"
            to="/cash-transfer"
          >
            Dashboard
          </NavLink>
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/cash-transfer/transaction"
          >
            Transaction
          </NavLink>
        </div>
        <Switch>
          <Route exact path={`${match.path}`} component={DashboardContainer} />
          <Route
            path={`${match.path}/transaction`}
            component={TransactionContainer}
          />
        </Switch>
      </div>
    </>
  );
}

EWalletServiceContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(EWalletServiceContainer);
